<!--
 * @Author: linrui
 * @Date: 2021-12-26 11:54:17
 * @LastEditors: linrui
 * @LastEditTime: 2022-01-04 16:31:42
 * @FilePath: /wechat-frontend/zmtx/src/views/doctor/doctorQuery.vue
-->
<template>
  <div class="doctor-query">
    <PolicyPopup ref="policyPopupRef" v-model="checkedPrivacy" :show-check-box="false" :policy-content="privacyConfig.privacy_policy" @confirm-policy="handleConfirmPolicy" />
    <div class="userbar">
      <div class="userbar-bg"></div>
      <div class="userbar-box">
        <div class="userbar-info">
          <img class="avatar" :src="doctor_logout_icon" alt="" />
          <div class="name">{{ doctorInfo.name }}</div>
          <div class="userbar-info">
            <div class="doctor-step">
              <div class="step-item" v-for="(item, index) in steps" :key="index" :class="{ on: (queryInfo.active || queryInfo.active == 0) && queryInfo.active >= index }">
                <div class="step-num">{{ index + 1 }}</div>
                <div class="step-name">{{ item }}</div>
                <van-icon class="step-status" name="success" size="20" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="shadow-box query-msg" v-if="queryInfo.desc">
      <div class="title">温馨提示</div>
      <div class="cont" v-html="queryInfo.desc"></div>
    </div>
    <div class="shadow-box query-next" :style="'background: ' + nextBg[queryInfo.next] + ';'" v-if="queryInfo.showNext" @click="queryInfo.nextstep">
      <i class="iconfont" :class="'wxicon-' + stepsIcon[queryInfo.next]"></i>
      <div class="title">{{ steps[queryInfo.next] }}</div>
    </div>
    <div class="float-btn">
      <div class="float-btn-box">
        <div class="float-logout-btn shadow-box" @click="logout">
          <p>退出登录</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import doctor_logout_icon from '@/assets/doctor_logout_icon.png'
import { GetDoctorDetail, DoctorLogout, privacyReadDoc, getPrivacyConfig } from '../../api/api'
import { mapState, mapMutations } from 'vuex'
import { doctorStatus } from '@/utils/doctorStatus'
import { Dialog } from 'vant'
export default {
  name: 'DoctorQuery',
  data() {
    return {
      steps: ['注册申请', '培训考试', '医生备案', '印章接收', '项目授权'],
      stepsIcon: ['file-edit', 'file-protect', 'bookmark', 'stamp', 'file-protect'],
      nextBg: ['#4DC4EA', '#B67BB7', '#42D796', '#2573CE', ''],
      active: null, // 当前步骤
      queryInfo: {
        title: '',
        desc: '',
        active: null,
        next: null,
        showNext: false,
        nextstep: null
      },
      checkedPrivacy: false,
      privacyConfig: {},
      doctor_logout_icon
    }
  },
  computed: {
    ...mapState({
      doctorInfo: state => state.doctor.doctorInfo
    })
  },
  created() {
    if (this.$route.query && this.$route.query.isAdopted) {
      this.isAdopted = this.$route.query.isAdopted
    }
    if (!this.doctorInfo || (this.doctorInfo && !this.doctorInfo.id)) {
      this.$router.replace({
        name: 'DoctorLogin'
      })
      return
    }
    this.getInfo()
  },

  methods: {
    ...mapMutations(['setDoctorInfo', 'clearDoctorInfo', 'clearHasEre']),

    handleConfirmPolicy() {
      privacyReadDoc({
        doctor_id: this.doctorInfo.id
      })
        .then(() => {
          this.$refs.policyPopupRef.closePolicyPopup()
        })
        .catch(err => {
          this.$toast(err.response.data.message)
        })
    },

    getInfo() {
      GetDoctorDetail({
        params: { id: this.doctorInfo.id }
      })
        .then(async res => {
          this.setDoctorInfo(res.data.doctor)
          console.log(res.data, '查询医生申请状态')
          this.queryInfo = doctorStatus(res.data.doctor)
          const { data: privacyRes } = await getPrivacyConfig()
          console.log('🚀 ~ getPatient ~ privacyRes:', privacyRes)
          if (privacyRes.is_privacy_open === '1' && !res.data.doctor.is_privacy_read) {
            this.privacyConfig = privacyRes
            this.$refs.policyPopupRef.openPolicyPopup()
          }
          console.log(this.queryInfo, 'this.queryInfo查询个人信息')
        })
        .catch(err => {
          console.log('🚀 ~ getInfo ~ err:', err)
        //   this.clearDoctorInfo()
        //   this.clearHasEre()
        //   this.$router.replace({
        //     name: 'DoctorLogin'
        //   })
          this.$toast(err.response.data.message)
        })
    },
    logout() {
      Dialog.confirm({
        message: '确认要退出该账号吗？',
        confirmButtonText: '确认退出',
        confirmButtonColor: '#2aa8b1'
      })
        .then(() => {
          console.log('退出登陆')
          DoctorLogout({
            id: this.doctorInfo.id
          })
            .then(() => {
              this.clearDoctorInfo()
              this.clearHasEre()
              this.$router.replace({
                name: 'DoctorLogin'
              })
            })
            .catch(err => {
              this.$toast(err.response.data.message)
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less">
.doctor-query {
  .float-btn {
    position: fixed;
    bottom: 10px;
    left: 0;
    right: 0;
    padding: 9px 11px;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    .float-btn-box {
      // display: flex;justify-content: center;align-items: center;
      .shadow-box {
        box-shadow: 0 1px 9px 0 rgba(83, 60, 24, 0.3);
        margin: 0;
      }
      .float-logout-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        height: 44px;
        line-height: 44px;
        font-size: 16px;
        padding: 0 15px;
        color: #fff;
        background: #9f9f9f;
        p {
          margin: 0;
          font-size: 16px;
          color: #fff;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.doctor-query {
  padding-bottom: 60px;
  .userbar {
    position: relative;
    padding: 75px 15px 10px;
    .userbar-bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background-color: @theme-color;
      height: 150px;
      z-index: 50;
    }
    .userbar-box {
      position: relative;
      z-index: 51;
      background: #fff;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      padding: 15px 15px 10px;
    }
    .userbar-info {
      .display-flex;
      align-items: center;
      flex-direction: column;
      .avatar {
        margin-right: 0;
        margin-top: -55px;
        height: 70px;
        width: 70px;
        border-radius: 70px;
        overflow: hidden;
        img {
          object-fit: cover;
          height: 100%;
          width: 100%;
          display: block;
        }
      }
      .name {
        .flex-1;
        min-width: 0;
        padding: 5px;
        color: #333;
        font-size: 18px;
      }
    }
  }
  .doctor-step {
    .flex-1;
    min-width: 0;
    .display-flex;
    flex-wrap: wrap;
    .step-item {
      flex: 0 0 50%;
      .display-flex;
      align-items: center;
      margin: 6px 0;
      .step-num {
        width: 22px;
        height: 22px;
        line-height: 22px;
        border-radius: 22px;
        margin-right: 10px;
        text-align: center;
        color: #fff;
        background: #a4a4a4;
      }
      .step-name {
        color: #a4a4a4;
        font-size: 14px;
      }
      .step-status {
        display: none;
        margin-left: 10px;
      }
      &.on {
        .step-num {
          background: @theme-color;
        }
        .step-name {
          color: @theme-color;
        }
        .step-status {
          display: block;
          color: @theme-color;
        }
      }
    }
  }
  .query-msg {
    font-size: 14px;
    color: #333;
    .title {
      padding: 8px 12px;
      position: relative;
      &::after {
        content: '';
        display: block;
        height: 0;
        line-height: 1.4;
        border-bottom: #eee solid 1px;
        bottom: 0px;
        left: 10px;
        right: 10px;
        position: absolute;
      }
    }
    .cont {
      line-height: 1.4;
      padding: 8px 12px;
    }
  }
  .query-next {
    padding: 8px 12px;
    .display-flex;
    align-items: center;
    background: @theme-color;
    justify-content: center;
    .iconfont {
      font-size: 64px;
      vertical-align: middle;
      color: #fff;
    }
    .title {
      font-size: 28px;
      color: #fff;
      margin: 0 30px;
    }
  }
}
</style>
